import type { TransactionHeaderSummary } from '@/types/api/engagement'
import { TRANSACTION_STATUS } from '@/lib/constants/transaction-codes'

/**
 * Filters out reversed transactions from a transaction list
 */
export function filterNonReversedTransactions(
  transactions: TransactionHeaderSummary[]
): TransactionHeaderSummary[] {
  return transactions.filter(
    tx => tx.transactionHeaderStatusId !== TRANSACTION_STATUS.REVERSED
  )
}

/**
 * Gets the most recent transaction by creation date
 */
export function getMostRecentTransaction(
  transactions: TransactionHeaderSummary[]
): TransactionHeaderSummary | null {
  if (transactions.length === 0) return null
  
  const sorted = [...transactions].sort((a, b) => 
    new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime()
  )
  
  return sorted[0]
}

